const formSelectors = {
  form: '[data-add-to-cart-form]',
  formVariantInput: '[data-form-id]',
  addToCartButton: '[data-add-to-cart-button]',
  recipientName: '[name="properties[Recipient name]"]',
  recipientEmail: '[name="properties[Recipient email]"]',
  recipientSendOn: '[name="properties[Send on]"]',
  message: '[name="properties[Message]"]'
}

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = document.querySelector(formSelectors.form);
    this.formVariantInput = this.form.querySelector(formSelectors.formVariantInput);
    this.addToCartButton = document.querySelector(formSelectors.addToCartButton);
    this.recipientName = this.form.querySelector(formSelectors.recipientName);
    this.recipientEmail = this.form.querySelector(formSelectors.recipientEmail);
    this.recipientSendOn = this.form.querySelector(formSelectors.recipientSendOn);
    this.message = this.form.querySelector(formSelectors.message);

    this.registerEventListeners();
  }

  addToCart(data) {
    const requestDefaults = {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };

    return fetch('/cart/add.js', {
      ...requestDefaults,
      method: 'POST',
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => this.handleDrawer(response))
  }


  registerEventListeners() {
    document.addEventListener('option:update', (e) => {
      this.form.dataset.productId = e.detail.option;
      this.formVariantInput.value = e.detail.option;
    })

    this.addToCartButton.addEventListener('click', () => {

      if(this.formVariantInput.value.length <= 0) {
        return;
      }

      const properties = {};

      if (this.recipientName.value.length > 0) {
        properties['Recipient name'] = this.recipientName.value;
      }

      if (this.recipientEmail) {
        if (this.recipientEmail.value.length > 0 && this.recipientName.value.length > 0) {
          properties['Recipient email'] = this.recipientEmail.value;
        }  
      }         
          
      if (this.recipientSendOn && this.recipientSendOn.value.length > 0) {
        properties['Send on'] = this.recipientSendOn.value;
      }

      if (this.message.value.length > 0) {
        properties.Message = this.message.value;
      };

      if (this.recipientEmail && this.recipientEmail.value.length > 0 && this.recipientName && this.recipientName.value.length > 0) {
        properties['__shopify_send_gift_card_to_recipient'] = 'if_present';
        properties['Recipient email'] = this.recipientEmail.value;
      }

      /**
       * If it's a physical gift card, only pushes the name and message, otherwise pushes name, email, date, and message.
      */
      this.addToCart({
        items: [
          {
            id: +this.formVariantInput.value,
            quantity: 1,
            properties,
          }
        ]
      })
    })
  }

  handleDrawer (respData) {
    $('#cart-summary-overlay #shop-more').triggerHandler('click');

    const item = respData.items[0]

    let cartPopupTemplate = ['<div id="cart-summary-overlay" class="cart-summary-overlay">', '<div class="cart-summary-overlay__row-head">', '<div class="cart-summary-overlay__column-image">', '<div class="cart-summary-overlay__column-title">', theme.strings.products_added_notification_title, '</div>', '</div>', '<div class="cart-summary-overlay__column-item">', '<div class="cart-summary-overlay__column-title">', theme.strings.products_added_notification_item, '</div>', '</div>', '<div class="cart-summary-overlay__column-price-region">', '<div class="cart-summary-overlay__column-price">', '<div class="cart-summary-overlay__column-title">', theme.strings.products_added_notification_unit_price, '</div>', '</div>', '<div class="cart-summary-overlay__column-quantity">', '<div class="cart-summary-overlay__column-title">', theme.strings.products_added_notification_quantity, '</div>', '</div>', '<div class="cart-summary-overlay__column-total">', '<div class="cart-summary-overlay__column-title">', theme.strings.products_added_notification_total_price, '</div>', '</div>', '</div>', '</div>', '<div class="cart-summary-overlay__row-body">', '<div class="cart-summary-overlay__column-image">', '<img src="[[image_url]]" alt="[[encoded-title]]" />', '</div>', '<div class="cart-summary-overlay__column-item">', '<div class="cart-summary-overlay__title">[[title]]</div>', '<div class="cart-summary-overlay__mobile-price-row">', '<div class="cart-summary-overlay__mobile-unit-price">[[unit_price]]</div>', '<div class="cart-summary-overlay__mobile-quantity">', theme.strings.products_added_notification_quantity, '<span class="cart-summary-overlay__quantity">[[quantity]]</span>', '</div>', '<div class="cart-summary-overlay__mobile-line-price">[[line_price]]</div>', '</div>', '</div>', '<div class="cart-summary-overlay__column-price-region">', '<div class="cart-summary-overlay__column-price">', '<span class="cart-summary-overlay__unit-price">[[unit_price]]</span>', '</div>', '<div class="cart-summary-overlay__column-quantity">', '<span class="cart-summary-overlay__quantity">[[quantity]]</span>', '</div>', '<div class="cart-summary-overlay__column-total">', '<div class="cart-summary-overlay__line-price">[[line_price]]</div>', '</div>', '</div>', '<div class="cart-summary-overlay__column-subtotal">', '</div>', '<div class="cart-summary-overlay__actions">', '<a id="shop-more" class="button altcolour" href="#">', theme.strings.products_added_notification_keep_shopping, '</a>', '<a class="button to-cart" href="', theme.routes.cart_url, '">', theme.strings.products_added_notification_cart, '</a>', '</div>', '</div>'].join('');
        
    var cartShadeHTML = cartPopupTemplate;
    cartShadeHTML = cartShadeHTML.replace('[[title]]',  item.title);
    cartShadeHTML = cartShadeHTML.replace('[[encoded-title]]',  item.title.replace(/"/g, '&quot;').replace(/&/g, '&amp;'));
    cartShadeHTML = cartShadeHTML.replace(/\[\[quantity\]\]/g, item.quantity);
    cartShadeHTML = cartShadeHTML.split('[[line_price]]').join(theme.Shopify.formatMoney(item.final_line_price, theme.money_format));
    cartShadeHTML = cartShadeHTML.split('[[unit_price]]').join(theme.Shopify.formatMoney(item.final_price, theme.money_format));
    cartShadeHTML = cartShadeHTML.replace('[[image_url]]', theme.Shopify.formatImage(item.image, '170x'));
    let $cartShade = $(cartShadeHTML);

    $cartShade.find('#shop-more').bind('click', function () {
      $cartShade.animate({
        top: -$cartShade.outerHeight()
      }, 500, function () {
        $(this).remove();
      });
    })

    $cartShade.prependTo('body').css('top', -$cartShade.outerHeight()).animate({
      top: 0
    }, 500); //Enable add button
        
    $(window).off('.ajaxAddScroll').on('scroll.ajaxAddScroll', function () {
      // Hide notifications on scroll
      $('#cart-summary-overlay #shop-more').triggerHandler('click');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('add-to-cart', AddToCart);
})
